import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23e5806f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-previous-locations-wrapper" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show previous locations", -1))
const _hoisted_5 = [
  _hoisted_4
]

import 'leaflet/dist/leaflet.css'
import { Icon, LatLng, latLng } from 'leaflet'
import { LControl, LLayerGroup, LMap, LMarker, LTileLayer, LTooltip } from '@vue-leaflet/vue-leaflet'
import { computed, onBeforeMount, ref, watch } from 'vue'
import { getCurrentGeoLocation, guid } from '@/helpers/tools'
import { Location, MapClickEvent, MapMarker, MarkerProp, Size } from '@/types/app'
import AppIconLoadingButton from "@/components/app/AppIconLoadingButton.vue";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";

interface Props {
  zoom?: number,
  size: Size,
  center?: Location,
  markers?: MarkerProp[],
  class?: string
}


// const defaults = {zoom: 13, location: {lon: 0, lat: 0}}
const defaults = { zoom: 13, location: { lon: 28.4478442, lat: 49.2207507 } }

export default /*#__PURE__*/_defineComponent({
  __name: 'AppMap',
  props: {
    zoom: { default: defaults.zoom },
    size: null,
    center: { default: () => (defaults.location) },
    markers: { default: () => [] },
    class: null
  },
  emits: ["centerChanged"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'centerChanged', location: Location): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { zoom: number, size: Size, center: Location, markers: MarkerProp[], class?: string };

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

function latLon2Marker ({ lat, lon, tooltip }: MarkerProp): MapMarker {
  return {
    latlng: latLng(lat, lon),
    tooltip
  }
}





const id: string = guid()
const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
const attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'

const current = ref<{ zoom: number, center: Location }>({ zoom: defaults.zoom, center: defaults.location })
const visibility = ref<{ map: boolean, markers: boolean }>({ map: false, markers: false })
const lock = ref<{ currentLocationResolving: boolean }>({ currentLocationResolving: false })

watch((): Location => current.value.center, (latlon: Location): void => {
  emit('centerChanged', latlon)
})

const mapCenter = computed((): LatLng => latLng(current.value.center.lat, current.value.center.lon))
const mapPreviousLocationMarkers = computed((): MapMarker[] => ((visibility.value.markers ? props.markers : []) as MarkerProp[]).map(latLon2Marker))
const mapMarkers = computed((): MapMarker[] => ([current.value.center] as Location[]).map(latLon2Marker))

function onMapClick (event: MapClickEvent): void {
  if (!event.originalEvent) return

  current.value.center = { lat: event.latlng.lat, lon: event.latlng.lng }
}

function onMarkerClick (event: MapClickEvent): void {
  current.value.center = { lat: event.latlng.lat, lon: event.latlng.lng }
}

function resolveCurrentLocation (updateCenter = false): Promise<Location> {
  lock.value.currentLocationResolving = true

  const currentLocationPromise = getCurrentGeoLocation({ enableHighAccuracy: true, timeout: 10 * 1000 })
      .finally((): void => {
        lock.value.currentLocationResolving = false
      })

  if (updateCenter) {
    currentLocationPromise.then((currentLocation: Location): Location => {
      current.value.center = currentLocation

      return currentLocation
    })
  }

  return currentLocationPromise
}

onBeforeMount(async (): Promise<void> => {
  current.value.zoom = props.zoom
  current.value.center = props.center || (await resolveCurrentLocation())

  visibility.value.map = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (visibility.value .map)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(props.size)
        }, [
          _createVNode(_unref(LMap), {
            class: "border border-secondary rounded-sm",
            options: { zoomSnap: 0.1, zoomDelta: 0.1 },
            zoom: current.value.zoom,
            "zoom-animation": true,
            "min-zoom": 3,
            "max-zoom": 19,
            center: _unref(mapCenter),
            onClick: onMapClick
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LTileLayer), {
                url: url,
                attribution: attribution
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapMarkers), (marker, index) => {
                return (_openBlock(), _createBlock(_unref(LMarker), {
                  key: `map-marker-key-${index}`,
                  "lat-lng": marker.latlng
                }, {
                  default: _withCtx(() => [
                    (marker.tooltip)
                      ? (_openBlock(), _createBlock(_unref(LTooltip), {
                          key: 0,
                          options: {permanent: true, interactive: false}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(marker.tooltip), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["lat-lng"]))
              }), 128)),
              _createVNode(_unref(LLayerGroup), {
                "layer-type": "overlay",
                name: "Previous locations"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapPreviousLocationMarkers), (marker, index) => {
                    return (_openBlock(), _createBlock(_unref(LMarker), {
                      key: `map-previous-marker-marker-key-${index}`,
                      "lat-lng": marker.latlng,
                      onClick: ($event: any) => (onMarkerClick(marker))
                    }, {
                      default: _withCtx(() => [
                        (marker.tooltip)
                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                              key: 0,
                              options: {permanent: true, interactive: false}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(marker.tooltip), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["lat-lng", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_unref(LControl), { position: "bottomleft" }, {
                default: _withCtx(() => [
                  _createVNode(AppIconLoadingButton, {
                    loading: lock.value.currentLocationResolving,
                    icon: "map-marker-alt",
                    "button-small": true,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (resolveCurrentLocation(true)))
                  }, null, 8, ["loading"])
                ]),
                _: 1
              }),
              _createVNode(_unref(LControl), { position: "topright" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                      id: `show-previous-location-${_unref(id)}`,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visibility.value.markers) = $event)),
                      type: "checkbox"
                    }, null, 8, _hoisted_2), [
                      [_vModelCheckbox, visibility.value.markers]
                    ]),
                    _createElementVNode("label", {
                      for: `show-previous-location-${_unref(id)}`
                    }, _hoisted_5, 8, _hoisted_3)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["options", "zoom", "center"])
        ], 4))
      : (_openBlock(), _createBlock(AppLoadingMessage, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("Loading current location")
          ]),
          _: 1
        }))
  ]))
}
}

})